export default __webpack_public_path__ + "static/media/logo-small-white.5d730250.svg";